// Signed and Sorted app icon. Slate-navy clipboard with three white checkbox
// rows + a prominent green checkmark badge in the corner. On a bright-green
// rounded square background. Mirrors the locked Safe-and-Sorted family
// language: bright green = success, slate navy = ink.

interface Props {
  size?: number
  className?: string
  /** If true (default), draw the bright-green background. Drop when rendering
   *  on a non-white surface that already provides its own coloured chip. */
  showBackground?: boolean
}

export default function BrandMark({ size = 64, className, showBackground = true }: Props) {
  return (
    <svg
      className={className}
      width={size} height={size}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Signed and Sorted"
      role="img"
      style={{ display: 'block', margin: '0 auto', borderRadius: Math.round(size * 0.22) }}
    >
      {showBackground && (
        <rect x="0" y="0" width="256" height="256" rx="48" fill="#16A34A" />
      )}

      {/* Clipboard body */}
      <rect x="62" y="56" width="142" height="156" rx="20" fill="#0F172A" />

      {/* Three checkbox rows */}
      {[0, 1, 2].map(i => {
        const y = 86 + i * 38
        return (
          <g key={i}>
            <rect x="80" y={y} width="28" height="28" rx="4" fill="#FFFFFF" />
            <path
              d={`M ${86} ${y + 14} L ${94} ${y + 22} L ${104} ${y + 8}`}
              stroke="#0F172A" strokeWidth="3.5" fill="none"
              strokeLinecap="round" strokeLinejoin="round"
            />
            <rect x="120" y={y + 10} width={i === 2 ? 30 : 70} height="6" rx="3" fill="#FFFFFF" />
          </g>
        )
      })}

      {/* Green success badge — bottom-right, overlaps the clipboard */}
      <circle cx="182" cy="190" r="34" fill="#16A34A" stroke="#0F172A" strokeWidth="6" />
      <path
        d="M 166 192 L 178 204 L 200 178"
        stroke="#FFFFFF" strokeWidth="7" fill="none"
        strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  )
}
